// extracted by mini-css-extract-plugin
export default {"form":"styles_form__7WGGS","input":"styles_input__bcU++","buttons":"styles_buttons__oQAL3","captcha-wrapper":"styles_captcha-wrapper__D-2Ce","captcha":"styles_captcha__BzMWE"};